<template>
  <div class="container">
    <img src="https://img.xinjiaoyu.com/app/teacher.jpg" alt="" />
    <a class="android-download" @click="download('andiroid')">点击直接下载</a>
    <a class="ios-download" @click="download('ios')">点击直接下载</a>
    <div class="andiroid-version version">
      版本{{ andiroid.version }} {{ andiroid.time }}
    </div>
    <div class="ios-version version">版本{{ ios.version }} {{ ios.time }}</div>
    <div class="mask" v-if="isMask" @click="hide">
      <img src="http://dist.xinjiaoyu.com/app/tips.png" />
    </div>
    <div class="ios-mask" @click="download('ios')"></div>
    <div class="andiroid-mask" @click="download('andiroid')"></div>
  </div>
</template>
<script>
import api from '@/apis/api';
export default {
  data() {
    return {
      andiroid: {},
      ios: {},
      isMask: false,
    };
  },
  mounted() {
    document.body.style.overflow = 'auto';
    this.getAndiroidServer();
    this.getIosServer();
  },
  methods: {
    async getAndiroidServer() {
      let params = {
        scope: '1', //安卓教师端‘2’
      };
      let res = await api.getMessageServer(params);
      if (res.code === 200) {
        if (res.data) {
          this.andiroid = res.data;
        }
        console.log(res.data);
      }
    },
    async getIosServer() {
      let params = {
        scope: '12', //IOS教师端‘12’
      };
      let res = await api.getMessageServer(params);
      if (res.code === 200) {
        if (res.data) {
          this.ios = res.data;
        }
        console.log(res.data);
      }
    },
    download(type) {
      if (type === 'andiroid') {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          // alert('请用自带浏览器打开');
          this.isMask = true;
          document.body.style.overflowY = 'hidden';
          return false;
        } else {
          window.location.href = this.andiroid.applicationUrl;
        }
      } else {
        window.location.href = this.ios.applicationUrl;
      }
    },
    hide() {
      document.body.style.overflowY = 'auto';
      this.isMask = false;
    },
    // 时间转换格式
    timesFormatStr(times) {
      var time = new Date(times);
      return (
        time.getFullYear() +
        '/' +
        this.strRegion(time.getMonth() + 1) +
        '/' +
        this.strRegion(time.getDate())
      );
    },
    // 时间补位
    strRegion(timeStr) {
      if (parseInt(timeStr) <= 9) {
        return '0' + timeStr;
      }
      return timeStr;
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  font-size: 0;
  > img {
    width: 100%;
  }
}
a {
  position: absolute;
  font-size: 12px;
  top: 430px;
  left: 57px;
  display: block;
  color: #08080d;
  padding: 4px 10px;
  background: #fff;
  border-radius: 4px;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}
a.ios-download {
  left: 226px;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  img {
    position: absolute;
    top: 10px;
    right: 24px;
    width: 130px;
    height: auto;
  }
}
.version {
  position: absolute;
  top: 650px;
  width: 50%;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  &.andiroid-version {
    padding-left: 10px;
  }
  &.ios-version {
    right: 0;
    padding-right: 10px;
  }
}
.andiroid-mask {
  position: absolute;
  left: 36px;
  top: 466px;
  width: 134px;
  height: 138px;
  // border: 1px solid #000;
  box-sizing: border-box;
}
.ios-mask {
  position: absolute;
  right: 36px;
  top: 466px;
  width: 134px;
  height: 138px;
  // border: 1px solid #000;
  box-sizing: border-box;
}
</style>
